import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SortablejsModule } from "nxt-sortablejs";
import { Options as SortablejsOptions } from "sortablejs";
import { Survey, SurveyQuestion, SurveyQuestionType } from "../survey";

@Component({
    selector: "adapt-survey-question-container",
    standalone: true,
    imports: [SortablejsModule, FormsModule, CommonModule],
    templateUrl: "./survey-question-container.component.html",
    styleUrl: "./survey-question-container.component.scss",
})
export class SurveyQuestionContainerComponent {
    public sortableOptions: SortablejsOptions = {
        animation: 150,
    };

    @Input() public question!: SurveyQuestion;
    @Input() public survey!: Survey;

    public get questionNumber() {
        let value = 1;
        for (const question of this.survey.questions) {
            if (question === this.question) {
                return value;
            }

            if (question.type == SurveyQuestionType.options) {
                value++;
            }
        }

        throw new Error("Unknown question number");
    }

    public get guidanceText() {
        return this.question.subQuestion;
    }

    public get showQuestionNumber() {
        return this.question.type === SurveyQuestionType.options;
    }
}
